<template>
  <v-container fluid class="py-0">
    <v-row wrap align="center" justify="center" class="stack">
      <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-apple</v-icon>
        </div>
        <div class="text">iOS</div>
      </v-col>
      <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-android</v-icon>
        </div>
        <div class="text">Android</div>
      </v-col>
      <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-html5</v-icon>
        </div>
        <div class="text">HTML5</div>
      </v-col>
      <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-css3</v-icon>
        </div>
        <div class="text">CSS3</div>
      </v-col>
      <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-less</v-icon>
        </div>
        <div class="text">Less</div>
      </v-col>
      <!-- <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-sass</v-icon>
        </div>
        <div class="text">Sass</div>
      </v-col>-->
      <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-vuejs</v-icon>
        </div>
        <div class="text">Vue.js</div>
      </v-col>
      <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-js-square</v-icon>
        </div>
        <div class="text">JavaScript</div>
      </v-col>
      <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-react</v-icon>
        </div>
        <div class="text">React</div>
      </v-col>
      <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-node</v-icon>
        </div>
        <div class="text">Node.js</div>
      </v-col>
      <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-php</v-icon>
        </div>
        <div class="text">PHP</div>
      </v-col>
      <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-wordpress</v-icon>
        </div>
        <div class="text">Wordpress</div>
      </v-col>
      <!-- <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <div class="ts-mysql"></div>
        </div>
        <div class="text">MySQL</div>
      </v-col>-->
      <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-ethereum</v-icon>
        </div>
        <div class="text">Ethereum</div>
      </v-col>
      <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-bitcoin</v-icon>
        </div>
        <div class="text">Bitcoin</div>
      </v-col>
      <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-aws</v-icon>
        </div>
        <div class="text">Aws</div>
      </v-col>
      <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-git-square</v-icon>
        </div>
        <div class="text">Git</div>
      </v-col>
      <v-col xs="4" sm="3" md="1" class="stack-item">
        <div class="icon">
          <v-icon>fab fa-docker</v-icon>
        </div>
        <div class="text">Docker</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HomeTechStack",

  data: () => ({})
};
</script>
<style scoped lang="scss">
.stack {
  background-color: #1a4658;
  padding: 10px;
  .stack-item {
    .icon {
      text-align: center;
      margin-bottom: 5px;
    }
    .text {
      text-align: center;
      font-size: 0.7rem;
    }
  }
}
</style>